var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"grey-30 ra-app app-icon",attrs:{"src":_vm.url || '#',"width":_vm.width,"height":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }